import React, { useState, useMemo, useContext } from 'react';
import { Table, Icon, Input, Popup } from 'semantic-ui-react';
import { LowFlowDiversion } from '../../../models/LowFlowDiversion';
import { LookupsContext } from '../../../lookups/LookupFactory';

interface ILfdsUITableProps {
    lfds: LowFlowDiversion[];
    editLfd: Function;
    deleteLfd: Function;
}

const LfdsUITable = (props: ILfdsUITableProps) => {
    const [searchTerm, setSearchTerm] = useState('');

    const [lookups] = useContext(LookupsContext);

    const filteredData = useMemo(() => {
        if (!props.lfds) return [];
        if (!searchTerm) return props.lfds;

        return props.lfds.filter(lfd =>
            lfd.name?.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }, [props.lfds, searchTerm]);

    const getLfdTypeName = useMemo(() => (lfd: LowFlowDiversion) =>
        lookups.lutLowFlowDiversionType.find(x => x.id === lfd.lowFlowDiversionTypeId)?.name ?? '',
        [lookups]
    );

    return (
        <div className="lfds-ui-table">
            <div className="lfds-table__header">
                <Input
                    icon='search'
                    placeholder='Search LFDs...'
                    value={searchTerm}
                    onChange={(_, { value }) => setSearchTerm(value)}
                    style={{ width: '300px', height: '42px' }}
                />
            </div>

            <Table celled striped>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>LFD Name</Table.HeaderCell>
                        <Table.HeaderCell>LFD Type</Table.HeaderCell>
                        <Table.HeaderCell>Completion Date</Table.HeaderCell>
                        <Table.HeaderCell>Address</Table.HeaderCell>
                        <Table.HeaderCell>Daily Flow by Gallon</Table.HeaderCell>
                        <Table.HeaderCell>Jurisdiction</Table.HeaderCell>
                        <Table.HeaderCell>Actions</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {filteredData.map((lfd) => (
                        <Table.Row key={`${lfd.id}+${lfd.name}`}>
                            <Table.Cell>{lfd.name}</Table.Cell>
                            <Table.Cell>{getLfdTypeName(lfd)}</Table.Cell>
                            <Table.Cell>
                                {new Date(lfd.completionDate).toLocaleString([], { year: 'numeric', month: '2-digit', day: '2-digit' })}
                            </Table.Cell>
                            <Table.Cell>{lfd.street}</Table.Cell>
                            <Table.Cell>{lfd.dailyFlowGal}</Table.Cell>
                            <Table.Cell>{lfd.jurisdictionBreakdown}</Table.Cell>
                            <Table.Cell className="table-cell--actions">
                                <div className="icons-wrapper">
                                    <Popup
                                        trigger={
                                            <Icon
                                                name="pencil"
                                                onClick={() => props.editLfd(lfd)}
                                            />
                                        }
                                    >
                                        <Popup.Content>
                                            Edit LFD
                                        </Popup.Content>
                                    </Popup>
                                    <Popup
                                        trigger={
                                            <Icon
                                                name="trash"
                                                onClick={() => props.deleteLfd(lfd)}
                                            />
                                        }
                                    >
                                        <Popup.Content>
                                            Delete LFD
                                        </Popup.Content>
                                    </Popup>
                                </div>
                            </Table.Cell>
                        </Table.Row>
                    ))}
                    {filteredData.length === 0 && (
                        <Table.Cell colSpan={7} textAlign="center">
                            {searchTerm ? 'No LFDs found matching your search' : 'No LFDs available'}
                        </Table.Cell>
                    )}
                </Table.Body>
            </Table>

        </div>
    );
};

export default LfdsUITable;
